import { canPerform } from './canPerform'
import { isPublishSupported, PUBLISH_UNSUPPORTED } from './publishSupport'

export const NO_PUBLISH_ACCESS_CHANNEL_TOOLTIP =
  "You don't have Publish access to this channel."

export function getDisabledPublishChannelReason(channel?: {
  products?: readonly string[] | null
}): string {
  return channel && !isPublishSupported(channel)
    ? PUBLISH_UNSUPPORTED
    : NO_PUBLISH_ACCESS_CHANNEL_TOOLTIP
}

/**
 * Channels the actor can't view in Publish, as a Set for filter UIs to grey
 * out. Shared by the All Channels page and the calendar filters so the two
 * Publish surfaces can never disagree on which channels are disabled.
 *
 * Publish-only on purpose: Community and Insights derive their own disabled
 * sets because their rules combine the per-channel permission with a
 * product-capability gate — @see `useAllChannelsData` in Community's
 * `AllChannelsView` and `disabledChannelIds` in `AllChannelsInsightsPage`.
 * All three surfaces then apply their set the same way via
 * `selectEnabledChannelIds`.
 */
export function getDisabledChannelIds<
  T extends { id: string; allowedActions?: readonly string[] | null },
>(channels: readonly T[]): Set<string> {
  return new Set(
    channels
      .filter((channel) => !canPerform(channel, 'viewPublish'))
      .map((channel) => channel.id),
  )
}
